var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.owners.length === 1 && _vm.displayLabel)?_c('div',[_vm._v("Stock: "+_vm._s(this.firstOwnerLabel))]):_vm._e(),(_vm.owners.length > 1)?_c('SelectInput',_vm._g({attrs:{"name":"stock","label":_vm.$t('addShooting.stockLabel') + ' *',"itemValue":"ownerId","itemText":"label","items":_vm.ownersWithLabel}},_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }